import { Component, forwardRef, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { ArrayInput } from '../../models/inputs/array';
import { FormInputsComponent } from '../form-inputs/form-inputs.component';
import { InputLabelComponent } from '../input-label/input-label.component';
import { ValidationArrayMessagesComponent } from '../validation-array-messages/validation-array-messages.component';

@Component({
    selector: 'lib-form-array',
    templateUrl: './form-array.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        ButtonModule,
        InputLabelComponent,
        ValidationArrayMessagesComponent,
        forwardRef(() => FormInputsComponent)
    ],
    styles: [
        `
            .array-label {
                // padding-left: calc(calc(var(--bs-gutter-x) * 0.5) + 16px);
            }
            .form-group-array {
                padding-right: calc(var(--bs-gutter-x) * 0.5);
                padding-left: calc(var(--bs-gutter-x) * 0.5);
                margin-top: var(--bs-gutter-y);
            }
        `
    ]
})
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class FormArrayComponent<T = any> {
    @Input() form!: FormGroup;
    @Input() array!: ArrayInput<T>;
    @Input() name!: string;

    removeRow(i: number) {
        if (this.array.length === 1) {
            return;
        }
        this.array.removeAt(i);

        this.form.markAsDirty(); // la modifica all'array non viene altrimenti rilevata

        this.form.updateValueAndValidity({ emitEvent: true }); // la modifica all'array non viene altrimenti rilevata
    }

    addRow() {
        if (this.array.maxLength && this.array.maxLength === this.array.length) {
            return;
        }
        this.array.push();
    }
}
